import React from 'react';
import { GenericListPage } from '../../../components/generic';
import { useExpenseCategories, ExpenseCategory } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<ExpenseCategory>
      useData={useExpenseCategories}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;

